/** True when API seller profile represents an existing shop (name required; logo optional). */
export function sellerProfileHasShop(
  data: { id?: string; _id?: string; name?: string } | null | undefined
): boolean {
  if (!data) return false;
  const id = data.id ?? data._id;
  return Boolean(id && String(data.name ?? '').trim());
}
